import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfigBaseComponent } from '../../../models/config-base-component';
import { FormGroup, FormControl, NgForm, Validators } from '@angular/forms';

@Component({
  selector: 'app-dynamic-controls-container',
  templateUrl: './dynamic-controls-container.component.html',
  styleUrls: ['./dynamic-controls-container.component.css']
})
export class DynamicControlsContainerComponent extends ConfigBaseComponent implements OnInit {

  @Output() createdFormEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    debugger;
  
    const formGroup: any = {};
    const that = this;
    if (this.Pagina && this.Pagina.ConfigPage && this.Pagina.ConfigPage.Metadata && this.Pagina.ConfigPage.Metadata.length > 0) {

      if (this.frm && this.frm.form) {
        this.SetFormControlNgForm(this.Pagina.ConfigPage.Metadata);

      }
      else {
        this.SetFormControl(formGroup, this.Pagina.ConfigPage.Metadata);

        this.form = new FormGroup(formGroup);
        this.createdFormEventEmitter.emit(this.form)
      }
    }
  }
  /* 
    ngOnInit() {
      debugger;
      const formGroup: any = {};
      const that = this;
      if (this.Pagina && this.Pagina.ConfigPage && this.Pagina.ConfigPage.Controls && this.Pagina.ConfigPage.Controls.length > 0) {
  
        if (this.frm && this.frm.form) {
          this.SetFormControlNgForm(this.Pagina.ConfigPage.Controls);
  
        }
        else {
          this.SetFormControl(formGroup, this.Pagina.ConfigPage.Controls);
  
          this.form = new FormGroup(formGroup);
          this.createdFormEventEmitter.emit(this.form)
        }
      }
    } */
  SetFormControl(formGroup: any, controls: Array<any>) {

    const that = this;
    if (controls && controls.length > 0) {
      controls.forEach(formControl => {

        if (this.utility.EsControlFormulario(formControl)) {
          formGroup[formControl.Name] = new FormControl('');
          const ctr = new FormControl('');
          ctr.setValue(formControl.Value);
          setTimeout(() => {
            ctr.markAsTouched();
          }, 3000);
        }
        else {
          if (formControl.Controls && formControl.Controls.length > 0) {
            this.SetFormControl(formGroup, formControl.Controls)
          }
        }
      });
    }
  }

  SetFormControlNgForm(controls: Array<any>) {

    if (controls && controls.length > 0) {
      controls.forEach(formControl => {

        if (this.utility.EsControlFormulario(formControl)) {
          const ctr = new FormControl('');
          ctr.setValue(formControl.Value);
          setTimeout(() => {
            ctr.markAsTouched();
          }, 3000);

          this.frm.form.addControl(formControl.Name, ctr);
        }
        else {
          if (formControl.Controls && formControl.Controls.length > 0) {
            this.SetFormControlNgForm(formControl.Controls)
          }
        }
      });
    }
  }
}
